export const GOOGLE_SSO_CREDENTIAL_KEY = 'google_sso_credential'

/** Per-tab carry-over of the invitation token while the user picks Player vs Guardian. */
export const GOOGLE_SSO_INVITATION_TOKEN_KEY = 'google_sso_invitation_token'

/** Appended to return URL after bind completes so the shell can toast and refresh profile. */
export const GOOGLE_LINK_SUCCESS_QUERY = 'googleLinked'
export const GOOGLE_LINK_SUCCESS_VALUE = '1'

/** ProfileDropdown opens My Account once after handler processes the success query. */
export const GOOGLE_LINK_OPEN_ACCOUNT_SESSION_KEY = 'rallyp_open_my_account_after_google_link'

/** After Google-only user signs in with Google (from login modal), open My Account to set a password. */
export const OPEN_MY_ACCOUNT_PASSWORD_SETUP_SESSION_KEY = 'rallyp_open_account_password_setup_after_google'

/** Query param when redirecting across subdomains (sessionStorage does not carry). */
export const OPEN_MY_ACCOUNT_URL_QUERY = 'openMyAccount'
